// pages/AssetsFormPage/ChartPresetPicker.jsx
import styles from './assetsformpage.module.css';

const PRESETS = [
  { id: 'bar', label: 'Barras (Horizontal)' },
  { id: 'bar_track', label: 'Barras (Horizontal) com acompanhamento' },

  { id: 'column', label: 'Colunas (Vertical)' },
  { id: 'column_track', label: 'Colunas (Vertical) com acompanhamento' },

  { id: 'pie', label: 'Pizza' },
  { id: 'pie_track', label: 'Pizza com acompanhamento' },

  { id: 'donut', label: 'Donut' },
  { id: 'donut_track', label: 'Donut com acompanhamento' },

  { id: 'radar', label: 'Radar' },
  { id: 'radar_track', label: 'Radar com acompanhamento' },
];

export default function ChartPresetPicker({ value, onChange }) {
  return (
    <div className={styles.presetPicker}>
      <select
        className={styles.selectInput}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      >
        {PRESETS.map((p) => (
          <option key={p.id} value={p.id}>
            {p.label}
          </option>
        ))}
      </select>
    </div>
  );
}